module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMBAMAAAB2C0uMAAAAAXNSR0IB2cksfwAAADBQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWj8cCwAAABB0Uk5TAJCfoP/QEDCvsCDw789gQJ8axJ4AAAA/SURBVHicY2CAACEozcDsmgBlmYRhF2IvYGDI8AQJrT7OwHbFACTB51OQ6wxR8+Q8RAgouMUZZmq1AIzFBqEAmYkMQgGYZ5sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/general/icon-included.png
// module id = 42
// module chunks = 0